var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.clazz},[_c('label',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._t("default")],2),(_vm.help)?_c('div',{staticClass:"help-icon"},[_vm._t("helpContent")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }